import { castImmutable, produce } from 'immer';
import { createReducer, getCookie } from '@ovpn-ui/utils';
import { setAuthToken, getTenantAuth, editTenantAuth } from './auth.routines';
const tokenId = 'cvpn_token';
const ssoTokenId = 'sso_token';
const initialState = castImmutable({
    ssoToken: getCookie(ssoTokenId),
    token: getCookie(tokenId),
    tenantAuth: {
        type: null,
        loading: false,
    },
});
const reducerMap = {
    [setAuthToken]: (state) => produce(state, draft => {
        draft.ssoToken = getCookie(ssoTokenId);
        draft.token = getCookie(tokenId);
    }),
    [getTenantAuth]: {
        TRIGGER: (state) => produce(state, draft => {
            draft.tenantAuth.loading = true;
        }),
        FAILURE: (state) => produce(state, draft => {
            draft.tenantAuth.loading = false;
        }),
        SUCCESS: (state, { type }) => produce(state, draft => {
            draft.tenantAuth.type = type;
            draft.tenantAuth.loading = false;
        }),
    },
    [editTenantAuth]: {
        SUCCESS: (state, type) => produce(state, draft => {
            draft.tenantAuth.type = type;
        }),
    },
};
export function extendAuthReducer(externalReducerMap, externalInitialState) {
    return createReducer(Object.assign(Object.assign({}, reducerMap), externalReducerMap), Object.assign(Object.assign({}, initialState), externalInitialState));
}
const authReducer = createReducer(reducerMap, initialState);
export default authReducer;
